exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a{color:hotpink}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/ContactVenue.vue"],"names":[],"mappings":"AACA,EACE,aAAe,CAChB","file":"ContactVenue.vue","sourcesContent":["\na {\n  color: hotpink;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f9d4030","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContactVenue.vue
// module id = 193
// module chunks = 10